export const language = {
  zh: {
    'Certification': '资质',
  },
  en: {
    'Certification': 'Certification',
  }
};